import { IComponentOptions, IController, IScope } from 'angular';
import { IFunctionBinding } from '../../../classes';
import template from './tn-select-3.html';

/**
    Select component with support for simple arrays, 
    
    props: 
        model = default value
        options = an array of options
        label-prop = if options is an array of objects, the property name to use as the label
        placeholder = if set this will be used as the label for when an option is not selected. 

    example usage: 
   
        <div ng-init="optionsA = [1,2,3,4,5]">
            <dropdown options="optionsA"></dropdown>
        </div>
        <div
            ng-init="optionsB = [{ v: 1, l: 'a'}, { v: 2, l:'b'},{ v: 3, l: 'c'}]"
        >
            <dropdown model="undefined" options="optionsB" value-prop="v" label-prop="l"  placeholder="placeheld" on-changed="$ctrl.log(value);"></dropdown>
        </div>
 
 */


export interface ITnSelect3OnChangedArgs<T> {
    value: T;
}

/**
 *  IComboBox for string.
 */
export interface ITnSelect3Bindings<T = unknown> {
    model?: T;
    onChanged?: IFunctionBinding<ITnSelect3OnChangedArgs<T>>;
    options?: T[];
    labelProp?: keyof T;
    placeholder?: string;
}


export class TnSelect3Component<T> implements IController, ITnSelect3Bindings<T> {
    // Bindings
    public model?: T;
    public onChanged?: IFunctionBinding<ITnSelect3OnChangedArgs<T>, void>;
    public options: T[] = [];
    public labelProp?;
    public placeholder = '';

    // Locals
    public open = false;

    static $inject = ['$scope'];
    constructor(protected $scope: IScope) {}

    public toggle(): void {
        this.open = !this.open;
    }

    public select(option: T): void {
        this.model = option;
        this.onChanged && this.onChanged({value: this.model});
    }
}

export const TnSelect3ComponentOptions: IComponentOptions = {
    bindings: {
        model: '<',
        onChanged: '&',
        options: '<',
        labelProp: '@',
        placeholder: '@',
    },
    controller: TnSelect3Component,
    template,
};
